/** Components */
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useNavigate } from 'react-router-dom';

/** Types, Utils */
import type { ClassNameMap } from '@mui/material';
import type { Dispatch, SetStateAction } from 'react';

interface ResetPassDialogProps {
    state: boolean;
    dispatch: Dispatch<SetStateAction<boolean>>;
    styles: (props?: any) => ClassNameMap<'dialogTitle' | 'dialogActions' | 'dialogContent' | 'dialogContentText'>;
}

export const ResetPassDialog = ({ state, dispatch, styles }: ResetPassDialogProps) => {
    /** Hooks */
    const classes = styles();
    const navigate = useNavigate();

    return (
        <Dialog open={state} onClose={() => dispatch(false)}>
            <DialogTitle className={classes.dialogTitle}>Reset Password Success!</DialogTitle>

            <DialogContent className={classes.dialogContent}>
                <DialogContentText className={classes.dialogContentText} color="textPrimary">
                    Password has been reset successfully! You can now go to login page.
                </DialogContentText>
            </DialogContent>

            <DialogActions className={classes.dialogActions}>
                <Button variant="contained" disableElevation onClick={() => dispatch(false)}>
                    Cancel
                </Button>
                <Button
                    disabled={false}
                    variant="contained"
                    disableElevation
                    onClick={() => navigate('/login')}
                    autoFocus>
                    Go To Login
                </Button>
            </DialogActions>
        </Dialog>
    );
};
